import ResizeObserver from "resize-observer-polyfill";

const ro = new ResizeObserver(() => {});

export const activate = () => {
  ro.observe(document.body);
};
